import { BrowserRouter as Router, Route } from 'react-router-dom'
import { hot } from 'react-hot-loader'

import App from 'containers/App'
import { ScrollToTop } from 'routing/RouteUtils'
import CoursesLoader from 'containers/CoursesLoader'
import CourseList from 'components/CourseList'
import CourseDetailsRoute from 'components/CourseDetails/CourseDetailsRoute'
import { prefixUrl } from 'utils'

export default hot(module)(() => (
  <App>
    <CoursesLoader blocking>
      <Router basename={prefixUrl('/Pages/Curriculum/Default.aspx')}>
        <div>
          <Route path="/" exact component={CourseList} />
          <ScrollToTop>
            <Route path="/:courseId" component={CourseDetailsRoute} />
          </ScrollToTop>
        </div>
      </Router>
    </CoursesLoader>
  </App>
))
